__turbopack_context__.v({
  "className": "googlesans_e6a40fe9-module__Hv4P3G__className",
  "variable": "googlesans_e6a40fe9-module__Hv4P3G__variable",
});
